module.exports = __webpack_public_path__ + "static/media/save-target-icon.87b724cb.svg";